<small class="form-text">{{ 'form_line_count_text' | translate: [lineCount, lineLimit, limitLabel | translate] }}</small>
